module.exports = __webpack_public_path__ + "static/AIS BIZUP-9acf2682cd0b09352e4eb65a03791811.webp";